import * as React from 'react'

export const Code2Icon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12.8234 3.51883C13.0338 2.71762 13.8533 2.23916 14.6545 2.44949C15.4556 2.65989 15.9355 3.47939 15.7253 4.28055L11.3908 20.7805C11.1804 21.5817 10.361 22.0602 9.55975 21.8499C8.7586 21.6395 8.27873 20.82 8.48895 20.0188L12.8234 3.51883ZM5.65594 6.93777C6.25598 6.36667 7.20588 6.3905 7.77704 6.99051C8.34814 7.59055 8.32431 8.54044 7.7243 9.1116L4.53241 12.1497L7.7243 15.1878C8.32431 15.7589 8.34814 16.7088 7.77704 17.3089C7.20588 17.9089 6.25598 17.9327 5.65594 17.3616L1.32294 13.2366C1.02551 12.9535 0.857117 12.5603 0.857117 12.1497C0.857117 11.739 1.02551 11.3459 1.32294 11.0628L5.65594 6.93777ZM16.4372 6.99051C17.0084 6.3905 17.9583 6.36667 18.5583 6.93777L22.8913 11.0628C23.1887 11.3459 23.3571 11.739 23.3571 12.1497C23.3571 12.5603 23.1887 12.9535 22.8913 13.2366L18.5583 17.3616C17.9583 17.9327 17.0084 17.9089 16.4372 17.3089C15.8661 16.7088 15.8899 15.7589 16.4899 15.1878L19.6804 12.1497L16.4899 9.1116C15.8899 8.54044 15.8661 7.59055 16.4372 6.99051Z'
        fill='currentColor'
      />
    </svg>
  )
})

Code2Icon.displayName = 'Code2Icon'
